export const FUEL_PETROL = 1
export const FUEL_DIESEL = 2
export const FUEL_ELECTRIC = 3
export const FUEL_HYBRID = 4
export const FUEL_ETHANOL = 5
export const FUEL_HYDROGEN = 6
export const FUEL_GAS = 7
export const FUEL_LPG = 8
export const FUEL_OTHER = 9
export const FUEL_UNKNOWN = 10
export const FUEL_HYBRID_DIESEL = 11
export const FUEL_HYBRID_PETROL = 12

export const isSubjectToSoh = fuel =>
  [FUEL_ELECTRIC, FUEL_HYBRID, FUEL_HYBRID_DIESEL, FUEL_HYBRID_PETROL].includes(fuel)
